import type { GetConsumerPointsHistoryResponse } from "@jti/evo-client";
import type {
  BuyPrizeCodesType,
  CustomerPointsHistoryElement,
  CustomerPointsHistoryResponseType,
} from "@jti/rest-api-types";

export const convertEvoPointsHistory = (
  data: GetConsumerPointsHistoryResponse,
  statusCode?: number
): CustomerPointsHistoryResponseType => {
  const mapToLegacyType = (type: GetConsumerPointsHistoryResponse["data"][number]["type"]): string => {
    switch (type) {
      case "added":
        return "PointsWereAdded";
      case "spent":
        return "PointsWereSpent";
      case "expired":
        return "PointsTransferHasBeenExpired";
      case "canceled":
      case "points_transfer_canceled":
        return "PointsTransferHasBeenCanceled";
      case "points_were_refunded":
        return "PointsWereRefunded";
      default:
        return type;
    }
  };

  const items: CustomerPointsHistoryElement[] = data.data.map(
    ({
      balance_after,
      campaign,
      created_at,
      points,
      type,
      coupon,
      coupon_type,
      order_id,
      coupon_pin,
      is_added,
      issued_reward_status,
    }) => {
      return {
        type: mapToLegacyType(type),
        points,
        coupon: coupon ?? "",
        event: campaign,
        date: created_at,
        balance: balance_after,
        order_id: order_id ?? "",
        coupon_type: coupon_type ? (coupon_type as BuyPrizeCodesType) : undefined,
        coupon_pin,
        is_added,
        issued_reward_status,
      };
    }
  );

  return {
    items,
    total: data.meta.total || 0,
    statusCode: statusCode || 200,
  };
};
